<template>
    <v-col class="pa-0">
        <v-card class="flex round-card background-2">
            <v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Mail inviate</p>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-row class="pa-0 ma-0 pr-4">
                    <v-text-field class="hidden-xs-only font-weight-regular" v-show="expand"
                        append-icon="search"
                        label="Cerca"
                        v-model="search"
                        clearable
                        hide-details outlined dense
                    ></v-text-field>
                </v-row>
                <v-tooltip top>
					<template v-slot:activator="{ on }">
                        <v-btn @click="initialize()" :loading="loaderButton" v-on="on" icon>
                            <v-icon>refresh</v-icon>
                        </v-btn>
					</template>
                    <span>Refresh</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="expand = !expand" icon>
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>
                    </template>                    
                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                </v-tooltip>                
            </v-card-title>            
            <v-divider v-show="totalItems == 0 && expand"></v-divider>
		    <v-container class="py-0" fluid v-show="expand">
                <v-row class="ma-0">
				    <v-col cols="12" class="pa-3 hidden-sm-and-up">
                        <v-text-field
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-expand-transition>

                <v-data-iterator
                    v-show="expand"
                    :items="dataSteppers"
                    :options.sync="pagination"
                    :server-items-length="totalItems"
                    :footer-props="{
                        'items-per-page-options': [5, 10, 25, 50,  { text: 'Tutti', value: -1 }]
                    }">
                    <template v-slot:no-data>
                        <v-card class="background-2 fs12i pt-4 pb-4 mx-4" elevation="0">
                            <v-card-text class="text-center py-8">Non è stata ancora inviata alcuna email</v-card-text>
                            <v-card-text class="text-center pt-1" v-if="quickSend">
                                <v-btn text small ripple @click="$eventBusUtility.goTo($router, 'quotations-send-mail', clickModelId)"  color="indigo" class="fs11i" style="margin:auto">invia</v-btn>
                            </v-card-text>
                        </v-card>
                        <v-divider></v-divider>
                    </template>
                    <template v-slot:item="{item, header, value}">
                        <v-row class="pa-0 ma-0">
                            <v-col cols="12" class="pa-0">
                                <v-card class="flex py-0" elevation="0">
                                    <v-stepper v-model="stepper" :class="cardClass" vertical non-linear class="pb-0">
                                            <v-stepper-step
                                                id="mail-stepper" 
                                                class="fs13 w100p"  
                                                editable
                                                complete
                                                edit-icon="mail_outline"
                                                :step="item.id"
                                                :rules="[() => mailStatus(item.status)]"
                                                ><div class="flex w100p pa-1" style="display: flex;">
                                                    <span class="capitalize fw500 margin-auto ml0i mr0i"> {{ sendDate(item.send_date) | capitalize }}</span>
                                                    <span class="margin-auto mr5i ml5i">-</span>
                                                    <span class="margin-auto ml0i mr0i">{{ item.subject }}</span>
                                                    <span class="fw500 margin-auto mr0i">Stato: </span><v-chip class="ml5i mr0i margin-tb-auto" small outlined :color="mailStatus(item.status, 'color')">{{mailStatus(item.status, 'text')}}</v-chip>
                                                </div>
                                            </v-stepper-step>

                                            <v-stepper-content :step="item.id">
                                                <v-card color="background-1 fs12i" elevation="1" class="mb-4 pa-4">
                                                    <v-container class="pa-0" fluid>
                                                        <v-row style="overflow: auto">
                                                            <v-col lg="6" md="12" sm="12" cols="12" order-lg="1" order-sm="1" order="1" class="display-flex pr-1 pl-1 pb-2 pt-0">
                                                                <div class="fw500 margin-tb-auto">Da: </div><v-chip class="ml-2" small>{{ fromFormatText(item.from_name, item.from) }}</v-chip>
                                                            </v-col>
                                                            <v-col lg="6" md="12" sm="12" cols="12" order-lg="2" order-sm="3" order="3" class="display-flex pr-1 pl-1 pb-0 pt-0">
                                                                <template v-if="item.cc">
                                                                    <div class="fw500 margin-tb-auto">Cc: </div>
                                                                    <template v-for="(cc, c) in item.cc">
                                                                        <v-chip class="ml-2" small :key="c">{{cc}}</v-chip>
                                                                    </template>
                                                                </template>
                                                            </v-col>
                                                            <v-col lg="6" md="12" sm="12" cols="12" order-lg="3" order-sm="2" order="2" class="display-flex pr-1 pl-1 pb-0 pt-0">
                                                                <span class="fw500 margin-tb-auto"> A: </span> 
                                                                <template v-for="(to, t) in item.to">
                                                                    <v-chip class="ml-2" small :key="t">{{to}}</v-chip>
                                                                </template>
                                                            </v-col>
                                                            <v-col lg="6" md="6" sm="12" cols="12" order-lg="4" order-sm="4" order="4" class="display-flex pr-1 pl-1 pb-2 pt-0">
                                                                <template v-if="item.ccn">
                                                                    <div class="fw500 margin-tb-auto">Ccn: </div>
                                                                    <template v-for="(ccn, c) in item.ccn">
                                                                        <v-chip small :key="c">{{ccn}}</v-chip>
                                                                    </template>
                                                                </template>
                                                            </v-col>
                                                            <v-col class="pr-1 pl-1 pb-4 pt-4" lg="12" md="12" sm="12" cols="12" order-lg="5" order-sm="5" order="5" style="border-bottom: 1px solid #E0E0E0;">
                                                                <span class="fw500 margin-tb-auto mr5i">Oggetto: </span><span>{{item.subject}}</span>
                                                            </v-col>
                                                            <v-col class="pr-1 pl-1 pb-0 pt-4" lg="12" md="12" sm="12" cols="12" order-lg="6" order-sm="6" order="6" style="height: auto; max-height: 450px; overflow-y: auto;">
                                                                <div v-html="item.body" v-inline-files></div>
                                                            </v-col>
                                                            <v-col lg="12" md="12" sm="12" cols="12" order-lg="6" order-sm="6" order="6" class="display-flex pr-1 pl-1 pb-0 pt-4" style="border-top: 1px solid #E0E0E0;">
                                                                <div class="fw500 margin-tb-auto mr5i">Allegati: </div>
                                                                <template v-for="(attachment, a) in item.attachments">
                                                                    <!-- Attachment dalla pivot (oggetto con path) - scaricabile -->
                                                                    <v-chip
                                                                        v-if="attachment && typeof attachment === 'object' && attachment.path"
                                                                        outlined
                                                                        small
                                                                        :key="a"
                                                                        class="cursor-pointer"
                                                                        @click="handleAttachmentClick(attachment)"
                                                                    >
                                                                        <v-icon small left>mdi-download</v-icon>
                                                                        {{ attachment.origin_file_name || attachment.name }}
                                                                    </v-chip>
                                                                    <!-- Attachment vecchio formato (stringa) - solo visualizzazione -->
                                                                    <v-chip
                                                                        v-else
                                                                        outlined
                                                                        small
                                                                        :key="'str-' + a"
                                                                    >
                                                                        {{ typeof attachment === 'string' ? attachment : (attachment.name || attachment) }}
                                                                    </v-chip>
                                                                </template>
                                                            </v-col>

                                                            <template v-if="item.readers">
                                                                <v-col v-for="(type, r) in item.readers" :key="'reader_'+r" cols="12" class="d-flex pr-1 pl-1 pb-0 pt-3" order-lg="6" order-sm="6" order="6">
                                                                    <template v-if="type.read_at">
                                                                        <div class="fw500 margin-tb-auto mr5i">Letta da: </div>
                                                                        <v-chip v-if="type.read_at" small :key="r">{{ r }}&nbsp;-&nbsp;<span class="capitalize"> {{ formatDate(type.read_at) }}</span></v-chip>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class="fw500 margin-tb-auto mr5i">{{$trans(r)}}: </div>
                                                                        <template v-for="(recipient, d) in type">
                                                                            <v-chip small :key="d">{{ d }}&nbsp;-&nbsp;<span class="capitalize mx-1">{{ formatDate(recipient.datetime) }}</span>&nbsp;<span v-if="recipient.reason">({{recipient.reason}})</span></v-chip>
                                                                        </template>
                                                                    </template>
                                                                </v-col>
                                                            </template>

                                                        </v-row>
                                                    </v-container>
                                                </v-card>
                                            </v-stepper-content>
                                    </v-stepper>     
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-divider></v-divider>
                    </template>
                    <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                        Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                    </template>
                </v-data-iterator>
            </v-expand-transition>
        </v-card>

        <file-preview-dialog
            v-model="previewDialog"
            :doc="previewDoc"
            :url="previewUrl"
        />
    </v-col>
</template>

<script>
import FilePreviewDialog from '@/components/common/FilePreviewDialog'

export default {
	name: 'mail-logs',
	components: { FilePreviewDialog },
	props: {
		title: String,
		modelClass: String,
		modelId: Number,
		relation: String,
		cardClass: Array,
		quickSend: Boolean,
	},

	data() {
		return {
			stepper: 1,
			dataSteppers: [],
			pagination: {'itemsPerPage': 5},
			totalItems: 0,
			loaderButton: false,
			firstTime: true,
			secondTime: false,
			search: '',
            debounceUnwatch: {},
            expand: true,
            loadTimeout: null,
			previewDialog: false,
			previewDoc: null,
			previewUrl: null
		}
	},

	watch: {
		pagination: {
			handler: function(newValue, oldValue) {
                this.initialize()
			},
			deep: true,
		}
	},

	methods: {
		initialize() {
            if(this.loadTimeout) clearTimeout(this.loadTimeout)

            this.loadTimeout = setTimeout(() => {
                this.loaderButton = true
                let dataObject = {
                    page: this.pagination.page,
                    per_page: this.pagination.itemsPerPage,
                    sort: this.pagination.sortBy + '|' + (this.pagination.descending ? 'DESC' : 'ASC'),
                    id: this.modelId,
                    model_class: this.modelClass,
                    filter: this.search,
                }
                    
                this.axios.post('/maillogs', dataObject).then(response => {
                    // get body data
                    this.dataSteppers = response.data.data.data
                    this.totalItems = response.data.data.total
                    setTimeout(() => {this.loaderButton = false}, 500)
                        
                }, response => {
                    // error callback
                })
            },300)
		},

		formatDate(readDate) {
			return moment(readDate).format('dddd D MMMM YYYY HH:mm:ss') 
		},

		sendDate(date) {
			return moment(date, 'YYYY-MM-DD HH:mm:ss').format('dddd D MMMM YYYY HH:mm:ss')
		},

		fromFormatText(fromName, from) {
			if(fromName) {
				return fromName + ' - ' + from
			} else {
				return from
			}
		},

		mailStatus(status, type) {
			if(type === 'text') {
				if(status === 'sent') {
					return 'Inviata'
				} else {
					return 'Non Inviata'
				}
			} else if(type === 'color') {
				if(status === 'sent') {
					return 'success'
				} else {
					return 'error'
				}
			} else
			if(status === 'sent') {
				return true
			} else {
				return false
			}
		},

		isPreviewable(attachment) {
			var exts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'mp4', 'webm', 'pdf']
			return exts.includes((attachment.ext || '').toLowerCase())
		},

		handleAttachmentClick(attachment) {
			if (attachment.path && this.isPreviewable(attachment)) {
				this.previewDoc = { name: attachment.origin_file_name || attachment.name, ext: attachment.ext }
				this.previewUrl = '/files/' + attachment.path
				this.previewDialog = true
			} else {
				this.downloadAttachment(attachment)
			}
		},

		downloadAttachment(attachment) {
			if (attachment.path) {
				this.$eventBusUtility.getFile(this.$store, '/files/' + attachment.path, attachment.origin_file_name || attachment.name)
			}
		}
	},

	mounted() {
        this.debounceUnwatch = this.$watch('search', _.debounce(this.initialize, 700))

		this.$eventBusUtility.$on('refreshMailLogs', () => {
			this.initialize()
		})
        if (this.modelClass && this.$store.getters.checkSettings('compact_' + this.modelClass + '_view')) {
            this.expand = false
        } else {
            this.expand = !this.$store.getters.checkSettings('compact_viewing')
        }
        this.initialize()
    },
    
    beforeDestroy() {
        this.$eventBusUtility.$off('refreshMailLogs')
    }
}
</script>

<style>
#mail-stepper .v-stepper__label {
    width: 100% !important;
}
.v-stepper--vertical .v-stepper__step {
    padding: 8px 24px 8px !important;
}
.v-stepper__step__step .v-icon {
    font-size: 15px !important;
}
.v-margin-tb-auto {
    margin: auto;
    margin-right: 0;
    margin-left: 0;
}
.v-stepper__step.v-stepper__step--error .v-stepper__step__step .v-icon {
    font-size: 20px;
    color: inherit;
}
.v-stepper__content {
    padding-top: 8px !important;
}

</style>